import { AppState } from "../App";

export const guiShouldAllowSelectingAssetsOrPoints = (state: AppState): boolean => {
  if (state.mainGui.activeSelectionType === "LINE_SELECTION") {
    return false;
  }
  if (state.mainGui.activeTool === "RASTER_EDIT" && state.polygonEdit.status === "DRAWING_MODE") {
    return false;
  }
  if (state.mainGui.activeTool === "LEVEE_TOOL" && state.leveeEdit["status"] === "DRAWING_MODE") {
    return false;
  }
  if (state.mainGui.activeTool === "PUMP" && state.pumpMenu.placeOnMapMode === true) {
    return false;
  }

  if (state.mainGui.activeTool === "DISCHARGE" && state.dischargeMenu.placeOnMapMode === true) {
    return false;
  }
  // later others will come for RAIN and WIND

  return true;
};
